const WIRE_ACCOUNT_NAME = 'ITRVL, LLC';
const WIRE_BUSINESS_ADDRESS = 'ITRVL, LLC, 1250 Prospect St, Suite 300, La Jolla, CA 92037';
const WIRE_BANK_ADDRESS = 'Bank of America, 222 Broadway, New York, New York, 10038';
export const WIRE_ACCOUNT_NUMBER_DIRECT_CHANNEL = '3251-4375-4752';
export const WIRE_ACCOUNT_NUMBER_THIRD_PARTY = '3251-9978-0233';
export const WIRE_ROUTING_NUMBER = '026-009-593';
export const WIRE_DOMESTIC_SWIFT_CODE = 'BOFAUS3N';
export const WIRE_INTERNATIONAL_SWIFT_CODE = 'BOFAUS6S';

export function getWireDetails(isDomestic = true, useDirectChannelWire = false) {
  return {
    accountName: WIRE_ACCOUNT_NAME,
    businessAddress: WIRE_BUSINESS_ADDRESS,
    bankAddress: WIRE_BANK_ADDRESS,
    accountNumber: useDirectChannelWire ? WIRE_ACCOUNT_NUMBER_DIRECT_CHANNEL : WIRE_ACCOUNT_NUMBER_THIRD_PARTY,
    swiftCode: isDomestic ? WIRE_DOMESTIC_SWIFT_CODE : WIRE_INTERNATIONAL_SWIFT_CODE,
    routingNumber: WIRE_ROUTING_NUMBER,
  };
}
